import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';

import Iconify from '../../../../components/Iconify';
import { DebounceInput } from 'react-debounce-input';
import { SmallFormTextField } from '../../../../components/small-fields/SmallFormTextField';
import { useAccomodationDiagram } from '../AccomodationDiagramContext';
import { ColorPicker } from '../../../../components/ColorPicker';
import { isIntegerString } from '../../../../services/functions';

export const EventRecordDialog = props => {
  const { open, setOpen, eventRecord, selectedEventGroup } = props;
  const { events, setEvents, nodes, updateNodesF, setSelectedEventGroup } = useAccomodationDiagram();
  const [name, setName] = React.useState(eventRecord.name);
  const [slotsCount, setSlotsCount] = React.useState(0);
  const [color, setColor] = React.useState('#000000');


  const handleColorChange = color => {
    setColor(color.hex);
  };

  const onSubmit = () => {
    const updatedEvents = events.map(ev => {
      if (ev.id === eventRecord.id) {
        const updatedGroups = selectedEventGroup && selectedEventGroup.eventGroup
          ? ev.groups.map(gr => gr.id === selectedEventGroup.eventGroup.id
            ? { ...gr, name, color, slotsCount }
            : gr
          )
          : [...ev.groups, { name, color, id: uuidv4(), slotsCount }];

        return {
          ...ev,
          groups: updatedGroups
        };
      }

      return ev;
    });
    setEvents(updatedEvents);
    if (selectedEventGroup) {
      // Aktualizujemy EventNode, a potem BedNode o nowe dane
      const existingEventNodes = nodes.filter(n => n.data.eventGroup && n.type == 'EventNode' && n.data.eventGroup.id == selectedEventGroup.eventGroup.id);
      const updatedColorEventNodes = existingEventNodes.map(n => ({ ...n, style: { ...n.style, backgroundColor: color }, data: {
        ...n.data,
        eventGroup: { ...n.data.eventGroup, color, name }
      } }));
      updateNodesF(updatedColorEventNodes);

      const existingBedNodes = nodes.filter(n => n.data.eventGroup && n.type == 'BedNode' && n.data.eventGroup.id == selectedEventGroup.eventGroup.id);
      const updatedBedNodes = existingBedNodes.map(n => ({ ...n, data: {
        ...n.data,
        eventGroup: { ...n.data.eventGroup, color, name }
      } }));
      updateNodesF(updatedBedNodes);
    }
    setSelectedEventGroup(null);
    setOpen(false);
  };

  React.useEffect(() => {
    if (selectedEventGroup) {
      setName(selectedEventGroup.eventGroup.name);
      setColor(selectedEventGroup.eventGroup.color);
      setSlotsCount(selectedEventGroup.eventGroup.slotsCount || 0);
    }
  }, [selectedEventGroup]);

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
    >
      <DialogTitle id="add-new-house-dialog">{selectedEventGroup
        ? `Edytuj grupę imprezy ${eventRecord.name}`
        : `Dodaj grupę do imprezy ${eventRecord.name}`}</DialogTitle>
      <DialogContent>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} mt={2}>
          <Typography variant="subtitle2" flex="1 1 30%">Nazwa grupy</Typography>
          <DebounceInput
            sx={{ flex: '1 1 100%' }}
            type="text"
            placeholder=""
            value={name}
            onChange={e => setName(e.target.value)}
            debounceTimeout={100}
            element={SmallFormTextField}
            autoFocus
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} mt={2}>
          <Typography variant="subtitle2" flex="1 1 30%">Ilość miejsc</Typography>
          <SmallFormTextField
            sx={{ flex: '1 1 100%' }}
            type="text"
            placeholder=""
            value={slotsCount}
            onChange={e => setSlotsCount(e.target.value)}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={2} mt={2}>
          <Typography variant="subtitle2" flex="1 1 30%">Kolor grupy</Typography>
          <ColorPicker color={color} handleColorChange={handleColorChange} width="100%" />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack>
          <Button
            fullWidth
            variant="contained"
            endIcon={<Iconify icon={'eva:save-fill'} />}
            onClick={onSubmit}
            disabled={!isIntegerString(slotsCount)}
          >
            Zapisz zmiany
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
